.root {
  border: 1px solid var(--color-border, #e4e4e7);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  // Reset <fieldset> defaults so it lays out like the other timeline cards.
  margin: 0;
  min-inline-size: 0;
  padding: 10px;
}

.root-is-destructive {
  border-color: var(--color-destructive, #ef4444);
  background: var(--color-destructive-subtle, #fef2f2);
}

.root-is-generate {
  border-color: var(--color-primary, #6366f1);
  background: var(--color-primary-subtle, #eef2ff);
}

.header {
  align-items: center;
  display: flex;
  gap: 6px;
}

.icon {
  flex-shrink: 0;
}

// Flat descendant selectors (project convention — no nested `&`).
.root-is-destructive .icon {
  color: var(--color-destructive, #ef4444);
}

.root-is-generate .icon {
  color: var(--color-primary, #6366f1);
}

.summary {
  color: var(--color-foreground, #18181b);
}

.actions {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}
